export enum TachoStatusWorker {
    Driving = 0,
    Work = 1,
    Rest = 2,
    Free = 3,
    Unkown = 4,
}
